import { render, staticRenderFns } from "./SlideEmployeePortal.vue?vue&type=template&id=45015cc6&scoped=true&"
var script = {}
import style0 from "./SlideEmployeePortal.vue?vue&type=style&index=0&id=45015cc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45015cc6",
  null
  
)

export default component.exports